import Vue from 'vue'
import Modal from './Modal'
import ConfirmModal from './ConfirmModal'

export default Modal

// 记录所有 Modal 的关闭方法
const destroyFns = []

/**
 * 打开新的 Modal
 * @param {string} [opt.title]
 * @param {string} opt.content
 * @param {function} [opt.onConfirm]
 * @param {function} [opt.onCancel]
 * @returns {{update: *, close: *}}
 */
Modal.open = function(opt) {
  const data = { visible: true }
  if (typeof opt === 'string') {
    data.content = opt
  } else {
    Object.assign(data, opt)
  }
  const modal = new (Vue.extend(ConfirmModal))()
  modal.$mount()
  modal.update(data)
  destroyFns.push(close)
  function destroy() {
    close()
    for (let i = 0; i < destroyFns.length; i++) {
      if (destroyFns[i] === close) {
        destroyFns.splice(i, 1)
        break
      }
    }
  }
  function close() {
    modal.close()
  }
  return {
    close: destroy,
    update: modal.update,
    confirm: modal.confirm,
    cancel: modal.cancel,
    open: modal.open
  }
}

/**
 * 关闭所有 Modal
 */
Modal.closeAll = function() {
  while (destroyFns.length) {
    const close = destroyFns.pop()
    close && close()
  }
}
